import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'

/**
 * BootstrapCollapsePersistence
 *
 * Remembers a Bootstrap collapse's open/closed state server-side. Listens to the
 * settled shown/hidden events on the collapse target and PATCHes a boolean to the
 * given URL. Pairs with bootstrap-collapse-chevron on the same element — that one
 * handles the icon, this one persists.
 *
 * Values:
 *   url — endpoint that accepts PATCH <param>[<key>]=true|false
 *   param — the model param wrapper (e.g. "kpi_template")
 *   key — the boolean attribute name to persist
 *   saved — reflects the last value the server accepted ("true"/"false")
 */
export default class extends Controller {
    static values = { url: String, param: String, key: String, saved: String }
    static targets = ['collapse']

    collapseTargetConnected(element) {
        this.shownHandler = () => this.#save(true)
        this.hiddenHandler = () => this.#save(false)
        element.addEventListener('shown.bs.collapse', this.shownHandler)
        element.addEventListener('hidden.bs.collapse', this.hiddenHandler)
    }

    collapseTargetDisconnected(element) {
        element.removeEventListener('shown.bs.collapse', this.shownHandler)
        element.removeEventListener('hidden.bs.collapse', this.hiddenHandler)
    }

    async #save(expanded) {
        const body = new FormData()
        body.append(`${this.paramValue}[${this.keyValue}]`, expanded)

        this.savedValue = ''
        const response = await patch(this.urlValue, { body, responseKind: 'turbo-stream' })
        if (response.ok) this.savedValue = String(expanded)
    }
}
